module.exports = __webpack_public_path__ + "static/img/1.c3d225b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/aleksis/1.jpg
// module id = xWnP
// module chunks = 0